import nonreactive from '@/lib/nonreactive';
import pinBdImage from '@/assets/images/pins/BD.png';
import pinBd2xImage from '@/assets/images/pins/BD@2x.png';
import pinBdHoverImage from '@/assets/images/pins/BD_hover.png';
import pinBdHover2xImage from '@/assets/images/pins/BD_hover@2x.png';
import pinCngImage from '@/assets/images/pins/CNG.png';
import pinCng2xImage from '@/assets/images/pins/CNG@2x.png';
import pinCngHoverImage from '@/assets/images/pins/CNG_hover.png';
import pinCngHover2xImage from '@/assets/images/pins/CNG_hover@2x.png';
import pinE85Image from '@/assets/images/pins/E85.png';
import pinE852xImage from '@/assets/images/pins/E85@2x.png';
import pinE85HoverImage from '@/assets/images/pins/E85_hover.png';
import pinE85Hover2xImage from '@/assets/images/pins/E85_hover@2x.png';
import pinElecImage from '@/assets/images/pins/ELEC.png';
import pinElec2xImage from '@/assets/images/pins/ELEC@2x.png';
import pinElecHoverImage from '@/assets/images/pins/ELEC_hover.png';
import pinElecHover2xImage from '@/assets/images/pins/ELEC_hover@2x.png';
import pinEndImage from '@/assets/images/pins/end.png';
import pinEnd2xImage from '@/assets/images/pins/end@2x.png';
import pinHyImage from '@/assets/images/pins/HY.png';
import pinHy2xImage from '@/assets/images/pins/HY@2x.png';
import pinHyHoverImage from '@/assets/images/pins/HY_hover.png';
import pinHyHover2xImage from '@/assets/images/pins/HY_hover@2x.png';
import pinLngImage from '@/assets/images/pins/LNG.png';
import pinLng2xImage from '@/assets/images/pins/LNG@2x.png';
import pinLngHoverImage from '@/assets/images/pins/LNG_hover.png';
import pinLngHover2xImage from '@/assets/images/pins/LNG_hover@2x.png';
import pinLpgImage from '@/assets/images/pins/LPG.png';
import pinLpg2xImage from '@/assets/images/pins/LPG@2x.png';
import pinLpgHoverImage from '@/assets/images/pins/LPG_hover.png';
import pinLpgHover2xImage from '@/assets/images/pins/LPG_hover@2x.png';
import pinStartImage from '@/assets/images/pins/start.png';
import pinStart2xImage from '@/assets/images/pins/start@2x.png';

const PIN_FUEL_IMAGES = {
  BD: pinBdImage,
  CNG: pinCngImage,
  E85: pinE85Image,
  ELEC: pinElecImage,
  HY: pinHyImage,
  LNG: pinLngImage,
  LPG: pinLpgImage,
};
const PIN_FUEL_IMAGES_2X = {
  BD: pinBd2xImage,
  CNG: pinCng2xImage,
  E85: pinE852xImage,
  ELEC: pinElec2xImage,
  HY: pinHy2xImage,
  LNG: pinLng2xImage,
  LPG: pinLpg2xImage,
};
const PIN_FUEL_IMAGE_WIDTH = 42;
const PIN_FUEL_IMAGE_HEIGHT = 56;
const PIN_FUEL_IMAGE_LETTER_SIZE = 13;

const PIN_FUEL_HOVER_IMAGES = {
  BD: pinBdHoverImage,
  CNG: pinCngHoverImage,
  E85: pinE85HoverImage,
  ELEC: pinElecHoverImage,
  HY: pinHyHoverImage,
  LNG: pinLngHoverImage,
  LPG: pinLpgHoverImage,
};
const PIN_FUEL_HOVER_IMAGES_2X = {
  BD: pinBdHover2xImage,
  CNG: pinCngHover2xImage,
  E85: pinE85Hover2xImage,
  ELEC: pinElecHover2xImage,
  HY: pinHyHover2xImage,
  LNG: pinLngHover2xImage,
  LPG: pinLpgHover2xImage,
};
const PIN_FUEL_HOVER_IMAGE_WIDTH = 60;
const PIN_FUEL_HOVER_IMAGE_HEIGHT = 80;
const PIN_FUEL_HOVER_IMAGE_LETTER_SIZE = 18;

const PIN_SEARCH_IMAGES = {
  green: pinStartImage,
  red: pinEndImage,
};
const PIN_SEARCH_IMAGES_2X = {
  green: pinStart2xImage,
  red: pinEnd2xImage,
};
const PIN_SEARCH_IMAGE_WIDTH = 23;
const PIN_SEARCH_IMAGE_HEIGHT = 46;

function getMapPixelRatio() {
  if (window.devicePixelRatio && window.devicePixelRatio > 1) {
    return 2;
  }
  return 1;
}

function getMapPinFuelImages() {
  if (getMapPixelRatio() === 2) {
    return PIN_FUEL_IMAGES_2X;
  }
  return PIN_FUEL_IMAGES;
}

function getMapPinFuelImageWidth() {
  return PIN_FUEL_IMAGE_WIDTH * getMapPixelRatio();
}

function getMapPinFuelImageHeight() {
  return PIN_FUEL_IMAGE_HEIGHT * getMapPixelRatio();
}

function getMapPinFuelImageLetterSize() {
  return PIN_FUEL_IMAGE_LETTER_SIZE * getMapPixelRatio();
}

function getMapPinFuelHoverImages() {
  if (getMapPixelRatio() === 2) {
    return PIN_FUEL_HOVER_IMAGES_2X;
  }
  return PIN_FUEL_HOVER_IMAGES;
}

function getMapPinFuelHoverImageWidth() {
  return PIN_FUEL_HOVER_IMAGE_WIDTH * getMapPixelRatio();
}

function getMapPinFuelHoverImageHeight() {
  return PIN_FUEL_HOVER_IMAGE_HEIGHT * getMapPixelRatio();
}

function getMapPinFuelHoverImageLetterSize() {
  return PIN_FUEL_HOVER_IMAGE_LETTER_SIZE * getMapPixelRatio();
}

function getMapPinSearchImages() {
  if (getMapPixelRatio() === 2) {
    return PIN_SEARCH_IMAGES_2X;
  }
  return PIN_SEARCH_IMAGES;
}

function getMapPinSearchImageWidth() {
  return PIN_SEARCH_IMAGE_WIDTH * getMapPixelRatio();
}

function getMapPinSearchImageHeight() {
  return PIN_SEARCH_IMAGE_HEIGHT * getMapPixelRatio();
}

function stationPinColor(fuel) {
  let pinClass = 'afdc-letter';
  const fuelsWithWhiteText = ['BD', 'CNG', 'LNG'];

  if (fuelsWithWhiteText.includes(fuel)) {
    pinClass += ' afdc-white';
  }

  return pinClass;
}

function stationPinLetter(index) {
  const letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];
  return letters[index];
}

const moduleState = {
  pixelRatio: 1,
  maxMarkerHeight: PIN_FUEL_HOVER_IMAGE_HEIGHT,
  maxMarkerWidth: PIN_FUEL_HOVER_IMAGE_WIDTH,
  data: {},
  fuels: Object.keys(PIN_FUEL_IMAGES),
};

const moduleGetters = {
  mapPixelRatio: (state) => state.pixelRatio,
  mapMaxMarkerHeight: (state) => state.maxMarkerHeight,
  mapMaxMarkerWidth: (state) => state.maxMarkerWidth,
  mapImageData: (state) => state.data,
  mapImageFuels: (state) => state.fuels,
};

const mutations = {
  setMapPixelRatio(state, pixelRatio) {
    state.pixelRatio = pixelRatio;
  },

  setMapImageData(state, data) {
    state.data = nonreactive.frozen(data);
  },
};

const actions = {
  // Generate all of the raw image data MapBox will use for rendering markers.
  // A few general notes on this approach:
  //
  // - MapBox GL essentially renders all markers as raster images (and treats
  //   them all as sprites internally), so we need to send MapBox GL images as
  //   binary PNG data, rather than SVGs.
  // - MapBox GL has some issues with text placement on markers, so the
  //   accepted approach seems to be pre-generating images with the text as
  //   part of the image. Maintaining all the fuel markers with all the A-J
  //   text doesn't seem fun, so we take a small performance hit on startup to
  //   dynamically draw and generate these PNGs with the A-J letters on top of
  //   each fuel marker.
  // - Ideally we could generate all these PNGs for MapBox GL based on our SVG
  //   data (render the SVGs to a canvas of any size, and then get PNGs out).
  //   This works well in most browsers, except IE11, which doesn't seem to
  //   want to draw SVGs into canvas elements. So for that reason, we do
  //   pre-generate the base markers (without text) in various sizes
  //   (retina/not retina, hover/not hover).
  //
  //   These images of different sizes are generated from the SVGs. The
  //   configuration for sizes is in the Inkfile, which can be used with
  //   https://github.com/wader/inkmake to generate new sizes (assuming you
  //   have inkmake and Inkscape installed).
  // - For the different PNG marker sizes, while we could just use the largest
  //   size possible (a retina version of the hover size), and then scale these
  //   dynamically within MapBox GL. However, MapBox GL doesn't seem to scale
  //   these in a super-crisp way, so that's why we are generating all of the
  //   explicit versions (retina/non-retina, hover size/normal size).
  async generateMapImageData({ commit }) {
    const data = {};
    const promises = [];

    const fuelWidth = getMapPinFuelImageWidth();
    const fuelHeight = getMapPinFuelImageHeight();
    const fuelLetterSize = getMapPinFuelImageLetterSize();
    const fuelHoverWidth = getMapPinFuelHoverImageWidth();
    const fuelHoverHeight = getMapPinFuelHoverImageHeight();
    const fuelLetterHoverSize = getMapPinFuelHoverImageLetterSize();

    // Create a canvas for generating lettered images dynamically.
    const canvas = document.createElement('canvas');
    canvas.width = fuelHoverWidth;
    canvas.height = fuelHoverHeight;
    const context = canvas.getContext('2d');

    const pinFuelImages = getMapPinFuelImages();
    const pinFuelHoverImages = getMapPinFuelHoverImages();
    Object.keys(pinFuelImages).forEach((fuel) => {
      // Determine the text color to use for this fuel marker.
      const letterColor = (stationPinColor(fuel) === 'afdc-letter afdc-white') ? '#fff' : '#000';

      // Dynamically generate the lettered marker images for the first 10
      // results (A-J).
      //
      // Ideally we could handle this within mapbox-gl directly, but it's
      // dynamic support of text doesn't properly support overlapping
      // situations: https://github.com/mapbox/mapbox-gl-js/issues/4064
      //
      // So instead, we generate the letters dynamically using canvas to load
      // the image and then draw the text on top, resulting in a new image.
      for (let index = 0; index < 10; index += 1) {
        // Determine the letter based on the index.
        const letter = stationPinLetter(index);

        // Generate the normal-sized images.
        promises.push(new Promise((resolve, reject) => {
          const img = document.createElement('img');
          img.width = fuelWidth;
          img.height = fuelHeight;
          img.onload = () => {
            try {
              // Add the plain image (without a letter).
              data[`pin-${fuel}`] = img;

              // Generate the lettered image.
              context.clearRect(0, 0, fuelWidth, fuelHeight);
              context.drawImage(img, 0, 0, fuelWidth, fuelHeight);
              context.font = `${fuelLetterSize}px Arial`;
              context.textAlign = 'center';
              context.fillStyle = letterColor;
              context.fillText(letter, fuelWidth / 2, fuelHeight * 0.45);

              const imageData = context.getImageData(0, 0, fuelWidth, fuelHeight);
              data[`pin-${fuel}-${index}`] = imageData;
              resolve();
            } catch (e) {
              reject();
            }
          };
          img.onerror = () => {
            reject();
          };
          img.src = pinFuelImages[fuel];
        }));

        // Generate the larger-sized (used when hovering) letter images.
        promises.push(new Promise((resolve, reject) => {
          const hoverImg = document.createElement('img');
          hoverImg.width = fuelHoverWidth;
          hoverImg.height = fuelHoverHeight;
          hoverImg.onload = () => {
            try {
              context.clearRect(0, 0, fuelHoverWidth, fuelHoverHeight);
              context.drawImage(hoverImg, 0, 0, fuelHoverWidth, fuelHoverHeight);
              context.font = `${fuelLetterHoverSize}px Arial`;
              context.textAlign = 'center';
              context.fillStyle = letterColor;
              context.fillText(letter, fuelHoverWidth / 2, fuelHoverHeight * 0.45);

              const imageData = context.getImageData(0, 0, fuelHoverWidth, fuelHoverHeight);
              data[`pin-hover-${fuel}-${index}`] = imageData;
              resolve();
            } catch (e) {
              reject();
            }
          };
          hoverImg.onerror = () => {
            reject();
          };
          hoverImg.src = pinFuelHoverImages[fuel];
        }));
      }
    });

    // Load the search location starting/ending pin images.
    const searchWidth = getMapPinSearchImageWidth();
    const searchHeight = getMapPinSearchImageHeight();
    const pinSearchImages = getMapPinSearchImages();
    Object.keys(pinSearchImages).forEach((color) => {
      promises.push(new Promise((resolve, reject) => {
        const img = document.createElement('img');
        img.width = searchWidth;
        img.height = searchHeight;
        img.onload = () => {
          data[`pin-search-location-${color}`] = img;
          resolve();
        };
        img.onerror = () => {
          reject();
        };
        img.src = pinSearchImages[color];
      }));
    });

    // Wait for all of the images to be loaded (since this may happen
    // asynchronously).
    await Promise.all(promises);
    commit('setMapPixelRatio', getMapPixelRatio());
    commit('setMapImageData', data);
  },
};

export default {
  state: moduleState,
  getters: moduleGetters,
  mutations,
  actions,
};
